import React from "react";
import { styled, keyframes, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// keyframes (MUI v5 / emotion-friendly)
const starsAnim = keyframes`
  0% { transform: translateY(110vh) translateZ(0); }
  100% { transform: translateY(-10vh) translateZ(0); }
`;

const twinkle = keyframes`
  0%, 80%, 100% {
    opacity: 0.7;
    box-shadow: 0 0 0 #fff, 0 0 0 #fff;
  }
  95% {
    opacity: 1;
    box-shadow: 0 0 2px #fff, 0 0 4px #fff;
  }
`;

// random helper (same semantics as your original)
function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

// generate the 50 nth-child css rules (runs once when module loads)
function generateChildCssRules(count = 50) {
    const obj = {};
    for (let i = 1; i <= count; i++) {
        const size = random(1, 3);
        const offset = random(0, 200) / 2;
        const delay = random(1, 100) / 5 / size - 1000;
        const duration = random(200, 2000) / 5 / size;
        obj[`.container:nth-child(${i})`] = {
            width: `${size}px`,
            height: `${size}px`,
            left: `${offset}vw`,
            animationDelay: `${delay}s`,
            animationDuration: `${duration}s`,
            // nested star inside the container
            "& .star": {
                width: "inherit",
                height: "inherit",
                background: `rgba(0, 0, 0, ${random(7, 10) / 10})`,
            },
        };
    }
    return obj;
}

// styled root component
const StarsRoot = styled("div")(() => ({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    zIndex: -8,
    "& .container": {
        position: "absolute",
        animation: `${starsAnim} linear infinite`,
        "& .star": {
            animation: `${twinkle} linear infinite`,
            borderRadius: "100%",
            transform: "translateZ(0)",
        },
    },
    // spread the generated nth-child rules here
    ...generateChildCssRules(50),
}));

export default function Stars() {
    const theme = useTheme();
    // same breakpoint logic as your original
    const numStars = useMediaQuery(theme.breakpoints.down("sm")) ? 20 : 50;

    return (
        <StarsRoot>
            {Array.from({ length: numStars }).map((_, i) => (
                <div key={i} className="container">
                    <div className="star" />
                </div>
            ))}
        </StarsRoot>
    );
}
